// import * as Parse from "parse";
import axios from "axios";

// Parse.initialize(process.env.REACT_APP_PARSE_APP_ID);

// Parse.serverURL = process.env.REACT_APP_SERVER_URL;

const axiosInstance = axios.create({
  // baseURL:"https://3p02javqgk.execute-api.ap-south-1.amazonaws.com/" ,
  // baseURL: "http://localhost:3001",
  // baseURL: "https://mittsure.qdegrees.com:3001",
  // baseURL: "https://mittsureone.mittsureone.com:3001",
  baseURL: "https://mittsureone.com:3001",
  // baseURL:"https://mittsure-one-backend.vercel.app",

  // baseURL: "https://adoring-rosalind.103-35-165-44.plesk.page:3001",
  // baseURL: "https://adoring-rosalind.103-35-165-44.plesk.page:3001",

  headers: {
    'Content-Type': 'application/json'
    // Add your other headers here
    // 'X-Custom-Header': 'value',parse
  },
});

const funcForMittlernURL = () => {
  // const url = "https://mittlearn.qdegrees.com" 
  const url = "https://mittlearn.com"
  return url;
};

const functionMittlernSeries = () => {
  // const allowedSeriesCategories = ["rbZPNJyEArp", "vm1ky38CcV8", "RE5eHzp3Nyf", "P4Jv8vdol9D", "hHVfPm3Olnf", "q2QPMUpApky"]; // QD
  const allowedSeriesCategories = [ "rbZPNJyEArp", "vm1ky38CcV8", "RE5eHzp3Nyf", "3dYBcUMJ1ID", "hHVfPm3Olnf", "q2QPMUpApky"]; // Live
  return allowedSeriesCategories;
}

const functionMittlernSeriesName = () => {
  // const allowedSeriesCategoriesName = ["luma learn", "think trail", "b4-emagix", "b5 pinaka", "worksheets", "b3 series"]; // QD
  const allowedSeriesCategoriesName = [ "luma learn", "think trail", "b4-emagix", "b5 pinaka", "worksheets", "b3 series"]; // Live
  return allowedSeriesCategoriesName;
}

axiosInstance.interceptors.request.use(
  (config) => {
    const sessionToken = localStorage.getItem('token')

    // Set the token in the 'cookie' header
    //console.log('Request Headers:', config.headers);
    config.headers['token'] = `token=${sessionToken}`;
    //console.log('Request Headers:', config.headers);
    return config;
  },
  (error) => {
    // Do something with the request error
    return Promise.reject(error);
  }
);

const axiosInstance1 = axios.create({
  baseURL: "https://mittsure.qdegrees.com:3001`",
  // baseURL:"https://3p02javqgk.execute-api.ap-south-1.amazonaws.com/",
  headers: {
    'Content-Type': 'multipart/form-data', // Change content type for file upload
    // Add your other headers here
    // 'X-Custom-Header': 'value',
  },

});
axiosInstance1.interceptors.request.use(
  (config) => {
    const sessionToken = localStorage.getItem('token')

    // Set the token in the 'cookie' header
    //console.log('Request Headers:', config.headers);
    config.headers['token'] = `token=${sessionToken}`;
    //console.log('Request Headers:', config.headers);
    return config;
  },
  (error) => {
    // Do something with the request error
    return Promise.reject(error);
  }
);

const funcForBaseURL = () => {
  return axiosInstance.defaults.baseURL;
};


const login = async (data) => {
  try {
    //console.log("hhelo")

    const response = await axiosInstance.post('/user/signin', {
      username: data.email,
      password: data.password
    });

    //console.log(response);
    // Assuming your server returns the user data upon successful login
    const user = response.data;
    return user;
  } catch (error) {
    //console.error(error);
    throw error;
  }

};

const verifyUserSession = async (data) => {
  try {
    //console.log("hhelo",data)

    const response = await axiosInstance.post(
      `/user/verifyUser?token=${(data)}`

    );
    //console.log('tessting',response);
    // Assuming your server returns the user data upon successful login
    const user = response.data;
    return user;
  } catch (error) {
    //console.error(error);
    throw error;
  }

};
const signout = async (data) => {
  try {
    //console.log("hhelo",data)

    const response = await axiosInstance.post(
      `/user/signout`

    );
    //console.log('tessting',response);
    // Assuming your server returns the user data upon successful login
    const user = response.data;
    return user;
  } catch (error) {
    //console.error(error);
    throw error;
  }

};

async function exportData(url, data) {
  try {
    const response = await axiosInstance.post(url, data, {
      responseType: 'blob', // Ensures response is treated as a file
    });

    if (response) {
      return response;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error exporting data:', error);
    throw error;
  }
}

const uploadMultipleImages = async (data) => {
  try {
    const response = await axiosInstance.post('/user/uploadMultipleImages', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response) {
      return response;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error uploading multiple images:', error);
    throw error;
  }
};


// const fetchEmployees = async (data,role,cluster,query) => {
//   try {
//     //console.log("hellomamn",data)
//     const response = await axiosInstance.post(`/user/getUsers`,{status:data,role:role,cluster:cluster,search:query});

//   // Check if the request was successful (status code 200)
//   if (response.status === 200) {
//     // Return the data from the response
//     return response.data;
//   } else {
//     // If the request was not successful, handle the error
//     throw new Error(`Request failed with status: ${response.status}`);
//   }
//   } catch (error) {
//     //console.error(error);
//     throw error;
//   }
// };

const fetchEmployees = async (data, role, cluster, query, pageNumber, recordPerPage) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/getUsers`, { status: data, role: role, cluster: cluster, search: query, pageNumber: pageNumber, recordPerPage: recordPerPage });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getUsersWeb = async (data, role, cluster, query, pageNumber, recordPerPage, rm, rsm, asm) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/getUsersWeb`, { status: data, role: role, cluster: cluster, search: query, pageNumber: pageNumber, recordPerPage: recordPerPage, rm: rm, rsm: rsm, asm: asm });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


// const fetchOrderDash = async (data,role,cluster,query) => {
//   try {
//     //console.log("hellomamn",data)
//     const response = await axiosInstance.post(`/order/fetchOrderDash`);

//   // Check if the request was successful (status code 200)
//   if (response.status === 200) {
//     // Return the data from the response
//     return response.data;
//   } else {
//     // If the request was not successful, handle the error
//     throw new Error(`Request failed with status: ${response.status}`);
//   }
//   } catch (error) {
//     //console.error(error);
//     throw error;
//   }
// };

const fetchOrderDash = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/fetchOrderDash`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getDropdownListForOrder = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/getDropdownListForOrder`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getOlympiadDropdownData = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/olympiad/getOlympiadDropdownData`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const verifyTransactions = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/olympiad/verifyTransactions`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllClassSubjectMappings = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/olympiad/getAllClassSubjectMappings`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const convertToOrder = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/convertToOrder`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const convertToOrderForWeb = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/convertToOrderForWeb`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getDropdownListForSpecimen = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/getDropdownListForSpecimen`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAllDataForDashBoard = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/getAllDataForDashBoard`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getCountVisit = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/visit/getCountVisit`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getCountVisitForWeb = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/getCountVisitForWeb`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const getCountFollowupVisits = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/getCountFollowupVisits`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const getPartyCountAssignedOrNot = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/getPartyCountAssignedOrNot`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getVisitSummaryData = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/getVisitSummaryData`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getDiscrepancyReportData = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/getDiscrepancyReportData`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getUsersForWork = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/getUsersForWork`, { status: data });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getFAQ = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getFAQ`, { status: data });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const fetchLeadSource = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getLeadSource`, { status: data });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const addLeadSource = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/addLeadSource`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getUsersBasedOnManager = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/getUserListBasedOnId`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const createAccessModule = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/createAccessModule`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const releaseDeviceId = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/releaseDeviceId`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getLatLong = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/getLatLong`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};
const getAccessModules = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/getAccessModules`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const fetchAccessModules = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/fetchAccessModules`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getAddOnsMenu = async data => {
  try {
    const response = await axiosInstance.post('/product/getAddOnsMenu', data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getWarehouseinPicklist = async data => {
  try {
    const response = await axiosInstance.post("/order/getWarehouseinPicklist", data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getAllDistri = async data => {
  try {
    const response = await axiosInstance.post("/party/getAllDistri", data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getAllOnbordedDistributors = async data => {
  try {
    const response = await axiosInstance.post("/party/getAllOnbordedDistributors", data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getAddOns = async data => {
  try {
    const response = await axiosInstance.post('/product/getAddOns', data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const updateLeadSource = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/updateLeadSource`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const updateMeetingWithDecisionMaker = async data => {
  try {
    const response = await axiosInstance.post(`/visit/updateMeetingWithDecisionMaker`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const updateFAQ = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/updateFAQ`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const deleteLeadSource = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteLeadSource`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const deleteInputSource = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteInputSource`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const deleteSchoolType = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteSchoolType`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};
const deleteReason = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteReason`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};
const deleteCity = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteCity`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const deleteAttendanceConfig = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteAttendanceConfig`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const deleteCustomerType = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteCustomerType`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const deleteOfRoutParty = async data => {
  try {
    const response = await axiosInstance.post(`/routeplan/deleteOfRoutParty`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const updateDateOfRoutParty = async data => {
  try {
    const response = await axiosInstance.post(`/routeplan/updateDateOfRoutParty`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const deleteOrder = async data => {
  try {
    const response = await axiosInstance.post(`/order/deleteOrder`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const fetchLeadRating = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getLeadRating`, { status: data });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const addLeadRating = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/addLeadRating`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const addDistributorToStockist = async data => {
  try {
    const response = await axiosInstance.post(`/party/addDistributorToStockist`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getPartyVisitCounts = async data => {
  try {
    const response = await axiosInstance.post(`/dashboard/getPartyVisitCounts`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getDashboardTotalsAll = async data => {
  try {
    const response = await axiosInstance.post(`/dashboard/getDashboardTotalsAll`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};
const updateLeadRating = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/updateLeadRating`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const deleteLeadRating = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteLeadRating`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const fetchLeadStatus = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getLeadStatus`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const addLeadStatus = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/addLeadStatus`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const updateLeadStatus = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/updateLeadStatus`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const deleteLeadStatus = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteLeadStatus`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const getUsersFieldRole = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/getUsersFieldRole`, { status: data });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchVisits = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/visit/fetchVisit`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchAllVisit = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/visit/fetchAllVisit`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchVisitById = async (data) => {
  try {
    const response = await axiosInstance.post(`/visit/fetchVisitById`, data);

    if (response.status == 200) {
      return response.data;
    }
    else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const endVisitByWeb = async (data) => {
  try {
    const response = await axiosInstance.post(`/visit/endVisitByWeb`, data);

    if (response.status == 200) {
      return response.data;
    }
    else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}


const endVisitByWebForForceClose = async (data) => {
  try {
    const response = await axiosInstance.post(`/visit/endVisitByWebForForceClose`, data);

    if (response.status == 200) {
      return response.data;
    }
    else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const ReleasePartyLocation = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/ReleasePartyLocation`, data);

    if (response.status == 200) {
      return response.data;
    }
    else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const ReleaseBaseLocatioForUser = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/ReleaseBaseLocatioForUser`, data);

    if (response.status == 200) {
      return response.data;
    }
    else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}


const releaseUserLocation = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/releaseUserLocation`, data);

    if (response.status == 200) {
      return response.data;
    }
    else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}
const getDataForAppDropDown = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/visit/getDataForAppDropDown`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllDataForDropdownParty = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getAllDataForDropdownParty`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchDashboardUsers = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardUsers`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};



const fetchDashboardSchool = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardSchool`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const fetchDashboardSchoolErpOnboard = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardSchoolErpOnboard`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const fetchDashboardTotalRevenueOrder = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardTotalRevenueOrder`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const getExpenseType = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getExpenseType`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getExpenseSubType = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getExpenseSubType`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const getExpensePurpose = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getExpensePurpose`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getLanguage = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getLanguage`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getDocumentListSchool = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getDocumentListSchool`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAuthor = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getAuthor`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getSchoolCategory = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getSchoolCategory`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchDashboardDistributor = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardDistributor`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const fetchDashboardProductRank = async (start, end) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardProductRank`, { startDay: start, endDay: end });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const fetchDashboardVisitVsOrderUser = async (start, end) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardVisitVsOrderUser`, { startDay: start, endDay: end });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const fetchDashboardDistributorOnboardingList = async (start, end) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardDistributorOnboardingList`, { startDay: start, endDay: end });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchDashboardSchoolOnboardingList = async (start, end) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardSchoolOnboardingList`, { startDay: start, endDay: end });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const fetchDashboardEmployeeWithRevenue = async (start, end) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardEmployeeWithRevenue`, { startDay: start, endDay: end });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchDashboardTotalEarningMonthWise = async (start, end) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardTotalEarningMonthWise`, { startDay: start, endDay: end });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const fetchDashboardTotalEarningSchoolMonthWise = async (start, end) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardTotalEarningSchoolMonthWise`, { startDay: start, endDay: end });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchDashboardOrderVsSpecimen = async (start, end, school, user) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardOrderVsSpecimen`, { startDay: start, endDay: end, partyId: school, userId: user });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const fetchDashboardTotalEarningDistributorMonthWise = async (start, end) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/dashboard/fetchDashboardTotalEarningDistributorMonthWise`, { startDay: start, endDay: end });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchAttendance = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/fetchAttendance`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAttendanceOfAll = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/getAttendanceOfAll`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchCurrentVisit = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/visit/fetchCurrentVisit`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAttendanceOfAllPunchedIn = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/getAttendanceOfAllPunchedIn`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAttendanceOfAllNotPunchedIn = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/getAttendanceOfAllNotPunchedIn`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAttendanceOfAllAllStaff = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/getAttendanceOfAllAllStaff`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllAssignedSpecimenItems = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/getAllAssignedSpecimenItems`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getProductWithSeries = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/getProductWithSeries`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAllSpecimens = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/getAllSpecimens`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllottedSpecimen = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/getAllottedSpecimen`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllotSpecimens = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/getAllotSpecimens`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getMyAllotSpecimens = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/getMyAllotSpecimens`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllSpecimensAlloted = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/getAllSpecimensAlloted`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getMyAcceptedAllotSpecimens = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/getMyAcceptedAllotSpecimens`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const acceptedSpecimenToUser = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/acceptedSpecimenToUser`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getSpecimenItemsById = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/specimen/getSpecimenItemsById`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAttendanceConfig = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/getAttendanceConfig`, data);

    // Check if the request was successful (status code 200)
    // if (response.status === 200) {
    // Return the data from the response
    return response.data;
    // } else {
    //   // If the request was not successful, handle the error
    //   throw new Error(`Request failed with status: ${response.status}`);
    // }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getTodayAttendancePnches = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/getTodayAttendancePnches`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getTodayNotPunchedUsers = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/getTodayNotPunchedUsers`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getTodayAllPunchStatus = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/getTodayAllPunchStatus`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAttendanceDetailsByDate = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/getAttendanceDetailsByDate `, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const exportFetchAttendance = async (data) => {
  try {
    const response = await axiosInstance.post(`/attendance/exportFetchAttendance`, data);


    if (response.status === 200) {

      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const fetchOrder = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/fetchOrder`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const makePayloadForMittlernIntigration = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/makePayloadForMittlernIntigration`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const fetchSingleOrder = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/fetchSingleOrder`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchOrderForTracking = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/fetchOrderForTracking`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchOrderLineItem = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/fetchOrderItem`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchOrderItemAll = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/fetchOrderItemAll`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const approverejectOrder = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/updateOrder`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const batchApproveOrders = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/batchApproveOrders`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const batchRejectOrders = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/batchRejectOrders`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateAsmApproval = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/updateAsmApproval`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateLatLongApprovalStatus = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/updateLatLongApprovalStatus`, data);

    // Check if the request was successful (status code 200)
    // if (response.status === 200) {4
    // Return the data from the response
    return response.data;
    // } else {
    //   // If the request was not successful, handle the error
    //   throw new Error(`Request failed with status: ${response.status}`);
    // }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const mergeParty = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/mergeParty`, data);

    // Check if the request was successful (status code 200)
    // if (response.status === 200) {4
    // Return the data from the response
    return response.data;
    // } else {
    //   // If the request was not successful, handle the error
    //   throw new Error(`Request failed with status: ${response.status}`);
    // }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const PartyUpdate = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/PartyUpdate`, data);

    // Check if the request was successful (status code 200)
    // if (response.status === 200) {4
    // Return the data from the response
    return response.data;
    // } else {
    //   // If the request was not successful, handle the error
    //   throw new Error(`Request failed with status: ${response.status}`);
    // }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getStockistForDropDown = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getStockistForDropDown`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getStockist = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getStockistWeb`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const getStockistAll = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getStockist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getSchool = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getSchool`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAllAreaSchool = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getAllAreaSchool`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAllAreaDistributor = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getAllAreaDistributor`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getMergedParty = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getMergedParty`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllSchool = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getAllSchool`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAllSchoolForMerge = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getAllSchoolForMerge`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getDistributor = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getDistributorWeb`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getTotalStudentByPartyId = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/olympiad/getTotalStudentByPartyId`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const swipeOwnerIdForSchool = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/swipeOwnerIdForSchool`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getDistributorA = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getDistributor`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const addSchool = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/addPartySchool`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addExpenseType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/addExpenseType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const addExpenseSubType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/addExpenseSubType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;

  }
};

const updateExpenseType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/updateExpenseType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateExpenseSubType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/updateExpenseSubType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateExpenseApproval = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/expense/updateExpenseApproval`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteExpenseType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/deleteExpenseType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteExpenseSubType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/deleteExpenseSubType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const editPartySchool = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/editPartySchool`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addDistributor = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/addDistributor`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const editDistributor = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/editDistributor`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const editStockist = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/editStockist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const approveRejectParty = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/approveRejectParty`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getUserById = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/getUsersById`, { "id": data });
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const getUsersForView = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/getUsersForView`, { "id": data });
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const fetchPinCode = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/address/getAddress`, { pincode: data });
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchPincodeFromAddress = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/address/fetchPincodeFromAddress`, data);
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const createNewUser = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/createNewUser`, data);
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const editUser = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/editUser`, { id: data.id, data });
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const deleteUser = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/deleteUser`, data);
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const suspendedUser = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/suspendedUser`, data);
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const activateUser = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/activateUser`, data);
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const fetchRoles = async () => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/role/getRole`);
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const getRole = async (data) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/user/getRoleUser`, data);

    return response.data;
    // } else {
    //   // If the request was not successful, handle the error
    //   throw new Error(`Request failed with status: ${response.status}`);
    // }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addRole = async (data) => {
  try {
    // //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/role/addRole`, data);
    //console.log("responsse", response)

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};




const getWorkType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/fetchWorkType`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addWorkType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/addWorkType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateWorkType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/updateWorkType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteWorkType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/deleteWorkType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const startAttendance = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/punchAttendance`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const endAttendance = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/attendance/endDay`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const fetchPartyType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/fetchPartyType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addPartyType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/addPartyType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updatePartyType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/updatePartyType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deletePartyType = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/deletePartyType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getSubject = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getSubject`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAllDistricts = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getAllDistricts`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllRouteNames = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getAllRouteNames`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addSubject = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/addSubject`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateSubject = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/updateSubject`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteSubject = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/deleteSubject`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getClass = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/getClass`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addClass = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/addClass`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateClass = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/updateClass`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteClass = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/picklist/deleteClass`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const fetchProduct = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/product/getProduct`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getMittstoreProduct = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/product/getMittstoreProduct`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getSpecimenProduct = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/product/getSpecimenProduct`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getMittplusProductGroups = async () => {
  try {
    const response = await axiosInstance.post(`/picklist/getProductTypeMittplus`);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addMittplusProductGroups = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addProductTypeMittplus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const updateMittplusProductGroups = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateProductTypeMittplus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteMittplusProductGroups = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteProductTypeMittplus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getProductGroups = async () => {
  try {
    const response = await axiosInstance.post(`/picklist/getProductGroup`);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addProductGroups = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addProductGroup`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const updateProductGroups = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateProductGroup`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteProductGroups = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteProductGroup`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getProducts = async (data) => {
  const payload = {
    "productType": data?.id
  }
  try {
    const response = await axiosInstance.post(`/product/getProductMittplusByProductType`, payload);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getReturnReasons = async () => {
  try {
    const response = await axiosInstance.post(`/picklist/getReturnReason`);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addReturnReasons = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addReturnReason`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const updateReturnReasons = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateReturnReason`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteReturnReasons = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteReturnReason`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addSchoolCategory = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addSchoolCategory`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const updateSchoolCategory = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateSchoolCategory`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteDistributor = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/deleteDistributor`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}
const deleteSchool = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/deleteSchool`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteStockist = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/deleteStockist`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteSchoolCategory = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteSchoolCategory`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addDocumentListSchool = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addDocumentListSchool`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const updateDocumentListSchool = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateDocumentListSchool`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteDocumentListSchool = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteDocumentListSchool`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addDeliveryStatus = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addDeliveryStatus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const updateDeliveryStatus = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateDeliveryStatus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteDeliveryStatus = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteDeliveryStatus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addMittplusProduct = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/addProductMittplus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const updateProduct = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/updateProduct`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateMittplusProduct = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/updateProductMittplus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteMittplusProduct = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/deleteProductMittplus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteTransporter = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/deleteTransporter`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteIncentive = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/deleteIncentive`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteIncentiveRule = async (data) => {
  try {
    const response = await axiosInstance.post(`/incentive/deleteIncentiveRule`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const calculateIncentiveForAllUsers = async (data) => {
  try {
    const response = await axiosInstance.post(`/incentive/calculateIncentiveForAllUsers`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const editIncentive = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/editIncentive`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}
const editIncentiveCondition = async (data) => {
  try {
    const response = await axiosInstance.post(`/incentive/updateIncentiveRule`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const editAddOnList = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/editAddOnList`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const editAddOnProducts = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/editAddOnProducts`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteSeriesSet = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/deleteSeriesSet`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteAddOnList = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/deleteAddOnList`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteAddOnProducts = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/deleteAddOnProducts`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}


const deleteProduct = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/deleteProduct`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const fetchProductMittplus = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/getProductMittplus`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getForecastReport = async (endpoint, payload = null) => {
  try {
    let response;
    if (payload) {
      response = await axiosInstance.post(`/dashboard/${endpoint}`, payload);
    } else {
      response = await axiosInstance.post(`/dashboard/${endpoint}`);
    }
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getFinancialReport = async (endpoint, payload = null) => {
  try {
    let response;
    if (payload) {
      response = await axiosInstance.post(`/dashboard/${endpoint}`, payload);
    } else {
      response = await axiosInstance.post(`/dashboard/${endpoint}`);
    }
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getPipelineReport = async (endpoint, payload = null) => {
  try {
    let response;
    if (payload) {
      response = await axiosInstance.post(`/dashboard/${endpoint}`, payload);
    } else {
      response = await axiosInstance.post(`/dashboard/${endpoint}`);
    }
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getOrderReport = async (endpoint, payload = null) => {
  try {
    let response;
    if (payload) {
      response = await axiosInstance.post(`/dashboard/${endpoint}`, payload);
    } else {
      response = await axiosInstance.post(`/dashboard/${endpoint}`);
    }
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getReturnOrderLineItemByReturnReasonId = async (payload) => {
  try {
    const response = await axiosInstance.post(`/dashboard/fetchReturnOrderLineItemByReturnReasonId`, payload);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addVisit = async (data) => {
  try {
    const response = await axiosInstance.post(`/visit/addVisitOfflineandDashboard`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const startVisit = async (data) => {
  try {
    const response = await axiosInstance.post(`/visit/startVisit`, data);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const updateVisit = async (data, data1) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/visit/updateVisit`, data);


    // Check if the request was successful (status code 200)
    if (response.status === 200) {

      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const testApi = async (data) => {
  try {
    // //console.log("hellomamn",data)
    const data = {

      "date": "1703818761",
      "oldPartyArray": ["R1dHetFQ8N", "4LaHZvAG4O"],
      "newPartyArray": ["new1221661612"]
    }
    const response = await axiosInstance.post(`/routeplan/addrouteplan`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getBoard = async () => {
  try {
    const response = await axiosInstance.post(`/picklist/getBoard`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const addBoard = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addBoard`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const updateBoard = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateBoard`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const deleteBoard = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteBoard`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const getMedium = async () => {
  try {
    const response = await axiosInstance.post(`/picklist/getMedium`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addMedium = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addMedium`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const updateMedium = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateMedium`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const deleteMedium = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteMedium`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchSeries = async () => {
  try {
    const response = await axiosInstance.post(`/product/fetchSeries`);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchProductById = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/fetchProductById`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addSeries = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/addSeries`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const createOrder = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/createOrder`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const createOlympiadRegistration = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/createOlympiadRegistration`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const createNewTicket = async (data) => {
  try {
    const response = await axiosInstance.post(`/ticket/createNewTicket`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


// const saveSOBOforOlympiad = async (data) => {
//   try {
//     const response = await axiosInstance.post(`/olympiad/saveSOBOforOlympiad`, data);

//     // Check if the request was successful (status code 200)
//     if (response.status === 200) {
//       // Return the data from the response
//       //console.log("TESTAPIRUN", response.data);

//       return response.data;
//     } else {
//       // If the request was not successful, handle the error
//       throw new Error(`Request failed with status: ${response.status}`);
//     }
//   } catch (error) {
//     //console.error(error);
//     throw error;
//   }
// }

const saveSOBOforOlympiad = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/saveSOBOforOlympiad`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
const updateStudyMaterialSOAttachment = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/updateStudyMaterialSOAttachment`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateInvoiceAttachmentsRC = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/updateInvoiceAttachmentsRC`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};


const updateInvoiceAttachments = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/updateInvoiceAttachments`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};


const addAttachmentToSOBOEntry = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/addAttachmentToSOBOEntry`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateRegStatusForDelivered = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateRegStatusForDelivered`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const createShipment = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/createShipment`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

const createGenerateInvoice = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/createGenerateInvoice`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};


const updateOlympiadRegistration = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateOlympiadRegistration`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const updateSOBOStatus = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateSOBOStatus`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateInvoicetatus = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateInvoicetatus`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateSetOffAmount = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateSetOffAmount`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const uploadTransactionAttachment = async (data) => {
  try {
    const response = await axiosInstance.post('/olympiad/uploadTransactionAttachment', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response) {
      return response;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error uploading multiple images:', error);
    throw error;
  }
};

const updateRoleAccess = async (data) => {
  try {
    const response = await axiosInstance.post(`/role/updateRoleAccess`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const fetchProduct1 = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/fetchProduct`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const addProduct = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/addProduct`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addIncentiveNew = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/addIncentiveNew`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addIncentiveNewCondition = async (data) => {
  try {
    const response = await axiosInstance.post(`/incentive/saveIncentiveRule`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const addInputSource = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addInputSource`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addSchoolType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addSchoolType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addReason = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addReason`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addCity = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addCity`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addAttendanceConfig = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addAttendanceConfig`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const addCustomerType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addCustomerType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addProductBulk = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/addProductBulk`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}



// const productByExcel=async(data)=>{
//   try{
//       const response = await axiosInstance.post(`/product/addProductByExcel`,data);

//     // Check if the request was successful (status code 200)
//     if (response.status === 200) {
//       // Return the data from the response
//       //console.log("TESTAPIRUN", response.data);

//       return response.data;
//     } else {
//       // If the request was not successful, handle the error
//       throw new Error(`Request failed with status: ${response.status}`);
//     }
//     } catch (error) {
//       //console.error(error);
//       throw error;
//     }
//     }   

const getSpecimen = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/getSpecimen`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addSpecimen = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/addSpecimen`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateSpecimen = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/updateSpecimen`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteSpecimen = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/deleteSpecimen`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const getAllTickets = async (data) => {
  try {
    const response = await axiosInstance.post(`/ticket/getAllTickets`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getRoutePlan = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/getRoutePlan`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const getRouteplanById = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/getRouteplanById`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const approveRoute = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/approveRoute`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const approvePartialRouteNotification = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/approvePartialRouteNotification`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const getPartyLead = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/getPartyLead`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const addRoutePlan = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/addRoutePlan`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addPartyInRouteLineItems = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/addPartyInRouteLineItems`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateRoutePlan = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/updateRoutePlan`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateOrderDetails = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/updateOrderDetails`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const updateRemarkInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/updateRemarkInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateClusterInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/updateClusterInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateEmailOfAdmin = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/updateEmailOfAdmin`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const updateSession = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateSession`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const updateSessionStatus = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateSessionStatus`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateWarehousekInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/updateWarehousekInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const fetchReportingManagerRole = async (data) => {
  try {
    const response = await axiosInstance.post(`/role/fetchReportingManagerRole`, { data });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getUsersOnRole = async (data) => {
  try {
    const response = await axiosInstance.post(`/role/getUsersOnRole`, { data });

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getCollection = async (data) => {
  try {
    const response = await axiosInstance.post(`/collection/getCollection`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addCollection = async (data) => {
  try {
    const response = await axiosInstance.post(`/collection/addCollection`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const approveRejectCollection = async (data) => {
  try {
    const response = await axiosInstance.post(`/collection/approveRejectCollection`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getGivenType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getGivenType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const addGivenType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addGivenType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateGivenType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateGivenType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteGivenType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteGivenType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteRemarkInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/deleteRemarkInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteClusterInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/deleteClusterInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteEmailOfAdmin = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/deleteEmailOfAdmin`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteSession = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteSession`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteWarehouseInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/deleteWarehouseInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getPaymentType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getPaymentType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addPaymentType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addPaymentType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updatePaymentType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updatePaymentType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deletePaymentType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deletePaymentType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const filterSchool = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/filterSchool`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const filterDistributor = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/filterDistributor`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const filterVisit = async (data) => {
  try {
    const response = await axiosInstance.post(`/visit/filterVisit`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const filterAttendance = async (data) => {
  try {
    const response = await axiosInstance.post(`/attendance/filterAttendance`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const filterOrder = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/filterOrder`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const filterOrderDistributor = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/filterOrderDistributor`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const filterRoutePlan = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/filterRoutePlan`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const filterCollection = async (data) => {
  try {
    const response = await axiosInstance.post(`/collection/filterCollection`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getSeriesCategory = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/getSeriesCategory`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAddOnListWeb = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/getAddOnListWeb`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAddOnsList = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/getAddOnsList`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAddOnProducttWeb = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/getAddOnProducttWeb`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAddOnProducttWeb1 = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/getAddOnProducttWeb1`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getRemarkInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/getRemarkInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getClusterInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/getClusterInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getEmailOfAdmin = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/getEmailOfAdmin`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllSessions = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getAllSessions`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getWareHouseInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/getWareHouseInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const saveAddOnList = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/saveAddOnList`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const saveAllotSpecimen = async (data) => {
  try {
    const response = await axiosInstance.post(`/specimen/saveAllotSpecimen`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200 || response.status === 201) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addRemarkInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/addRemarkInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addClusterInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/addClusterInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addEmailOfAdmin = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/addEmailOfAdmin`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addSession = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addSession`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addWarehouseInPicklist = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/addWarehouseInPicklist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const saveaddOnProducts = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/saveaddOnProducts`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addSeriesCategory = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/addSeriesCategory`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateSeriesCategory = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/updateSeriesCategory`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteSeriesCategory = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/deleteSeriesCategory`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getStatusType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getStatusType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addStatusType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addStatusType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateStatusType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateStatusType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteStatusType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteStatusType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const deleteCollection = async (data) => {
  try {
    const response = await axiosInstance.post(`/collection/deleteCollection`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};
const getVehicleType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getVehicleType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addVehicleType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addVehicleType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const exportUsers = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/exportUsers`, data);

    // Check if the request was successful (status code 200)
    if (response.status) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateVehicleType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateVehicleType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteVehicleType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteVehicleType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


// For DropDown
const getLeadParty = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/getPartyLead`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const getPartyLeadAdmin = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/getPartyLeadAdmin`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getTransporters = async data => {
  try {
    const response = await axiosInstance.post(`/party/getTransporter`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const GetAllIncentives = async data => {
  try {
    const response = await axiosInstance.post(`/incentive/GetAllIncentives`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getInputSourceList = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getInputSourceList`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getSchoolTypeList = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getSchoolTypeList`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getReasonList = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getReasonList`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getAllCities = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getAllCities`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getAllAttendanceConfigs = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getAllAttendanceConfigs`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}
const getQuestionCategory = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getQuestionCategory`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getCustomerTypeList = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getCustomerTypeList`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getIncentiveList = async data => {
  try {
    const response = await axiosInstance.post(`/order/getIncentiveList`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getIncentiveRules = async data => {
  try {
    const response = await axiosInstance.post(`/incentive/getIncentiveRules`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}
const getSchoolCategories = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getSchoolCategory`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const getVisitOutcomes = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/getVisitOutcome`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addVisitOutcomes = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/addVisitOutcome`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const updateVisitOutcomes = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/updateVisitOutcome`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteVisitOutcomes = async data => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteVisitOutcome`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const rejectVisit = async data => {
  try {
    const response = await axiosInstance.post(`/visit/rejectVisit`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const addLeadBulk = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/addLeadBulk`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addLeadAdmin = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/addLeadAdmin`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addTransporter = async data => {
  try {
    const response = await axiosInstance.post(`/party/addTransporter`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const updateTransporter = async data => {
  try {
    const response = await axiosInstance.post(`/party/updateTransporter`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

const deleteLead = async (data) => {
  try {
    const response = await axiosInstance.post(`/routeplan/deleteLead`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchAttendanceForReport = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/fetchAttendanceForReport`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const resetDeviceId = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/resetDeviceId`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const getSchoolForDropDown = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/getSchoolForDropDown`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const fetchLogs = async (data) => {
  try {
    const response = await axiosInstance.post(`/logs/fetchLogs`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const getWorkDone = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getWorkDone`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const addWorkDone = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addWorkDone`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateWorkDone = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateWorkDone`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateInputSource = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateInputSource`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateSchoolType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateSchoolType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateReason = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateReason`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateCity = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateCity`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateAttendanceConfig = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateAttendanceConfig`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const updateCustomerType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateCustomerType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteWorkDone = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteWorkDone`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getNextStep = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getNextStep`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addNextStep = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addNextStep`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateNextStep = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateNextStep`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteNextStep = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteNextStep`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchAllReasonForForceVisit = async (data) => {
  try {
    const response = await axiosInstance.post(`/visit/fetchAllReasonForForceVisit`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const getFeedback = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getFeedback`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const addFeedback = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addFeedback`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const updateFeedback = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateFeedback`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteFeedback = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteFeedback`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getContactPersonRole = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getContactPersonRole`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addContactPersonRole = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addContactPersonRole`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateContactPersonRole = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateContactPersonRole`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const deleteContactPersonRole = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteContactPersonRole`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getGrade = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getGrade`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addGrade = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addGrade`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateGrade = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateGrade`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteGrade = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteGrade`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const getDaType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getDaType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addDaType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addDaType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateDaType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateDaType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteDaType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteDaType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getVisitType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getVisitType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getVisitTypeCheck = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getVisitTypeCheck`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
}

const addVisitTypeCheck = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addVisitTimeCheck`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
}

const updateVisitTypeCheck = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateVisitTimeCheck`, data);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
}

const addVisitType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addVisitType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateVisitType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateVisitType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteVisitType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteVisitType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const getManager = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/getManager`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchProductByCategory = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/fetchProductByCategory`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getRouteVisitType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getRouteVisitType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const addRouteVisitType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addRouteVisitType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateRouteVisitType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateRouteVisitType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteRouteVisitType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteRouteVisitType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getRecieveCollectionName = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getRecieveCollectionName`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addrecieveCollectionName = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addrecieveCollectionName`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updaterecieveCollectionName = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updaterecieveCollectionName`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleterecieveCollectionName = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleterecieveCollectionName`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getBookType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getBookType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const addBookType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addBookType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateBookType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateBookType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteBookType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteBookType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getCollectiontype = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getCollectiontype`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addCollectionType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addCollectionType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateCollectionType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateCollectionType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteCollectionType = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteCollectionType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addStockist = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/addStockist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const sendOtp = async (data) => {
  try {
    data['token'] = JSON.parse(localStorage.getItem('storedUserData')).user.id
    const response = await axiosInstance.post(`/user/sendOtp`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const verifyOtp = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/verifyOtp`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const totalTimeWorkedReport = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/totalTimeWorkedReport`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getNotRoutePlanCreatedUsers = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getNotRoutePlanCreatedUsers`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getForceVisitClosedUsers = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getForceVisitClosedUsers`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getLocationMismatchCount = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getLocationMismatchCount`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getOverallAvgVisitsPerDay = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getOverallAvgVisitsPerDay `, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getUsersBelowAvgVisitMark = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getUsersBelowAvgVisitMark `, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const getAvgDailyVisitsPerUser = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getAvgDailyVisitsPerUser `, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getFollowUpVisitWithStatusReport = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getFollowUpVisitWithStatusReport `, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getFollowupChangedDateReport = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getFollowupChangedDateReport `, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getAutoVisitClosedUsers = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getAutoVisitClosedUsers `, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getJointMeeting = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getJointMeetingVisitReport `, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getVisitWithoutMeeting = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getVisitWithoutMeetingReport `, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getDailyVisitSummaryAt4PM = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getDailyVisitSummaryAt4PM`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getSummaryOne = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getSummaryOne`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getSummaryTwo = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/getSummaryTwo`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const sendNotification = async (data) => {
  try {
    const response = await axiosInstance.post(`/notification/sendNotification`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const calculateTimeForSchoolAndDistributor = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/calculateTimeForSchoolAndDistributor`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const resendOTP = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/resendOtpForSession`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const fetchNotifications = async (data) => {
  try {
    const response = await axiosInstance.post(`/notification/getNotification`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchNotificationForWeb = async (data) => {
  try {
    const response = await axiosInstance.post(`/notification/fetchNotificationForWeb`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getAllNotification = async (data) => {
  try {
    const response = await axiosInstance.post(`/notification/getAllNotification`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getPartyLocation = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/getPartyLocation`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getRequestTableList = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/getRequestTableList`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const MarkNotificationsRead = async (data) => {
  try {
    const response = await axiosInstance.post(`/notification/updateNotificationSeen`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchExpense = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/expense/fetchExpenses`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const verifyAllowance = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/expense/verifyAllowances`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const approveAllowance = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/expense/approveAllowance`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const findOrderBySchoolID = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/findOrderBySchoolID`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getExpenseTA = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/expense/getExpenseTA`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getUpdatedAllowances = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/expense/getUpdatedAllowances`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updatePincodeFromAddress = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/address/updatePincodeFromAddress`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getExpenseTADA = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/expense/getExpenseTADA`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAutomationLogs = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/order/getAutomationLogs`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};



const getExpenseTADAForWeb = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/expense/getExpenseTADAForWeb`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getExpenseDA = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/expense/getExpenseDA`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getallparty = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/party/getallparty`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const uploadImage = async (data) => {
  try {
    //console.log("checking upload", data);
    const response = await axiosInstance1.post('/user/uploadImage', data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const uploadImageApi = async (data) => {

  try {

    const res = await axiosInstance.post('/user/uploadImage', data);

    return [{
      link: res.data.link,
      status: res.data.status,
      message: res.data.message
    }];
  } catch (error) {
    return [{
      link: "",
      status: false,
      message: error.message
    }];
  }
};

const fetchAttendanceById = async (data) => {
  try {
    const response = await axiosInstance.post(`/attendance/fetchAttendanceById`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const getUpdatePartyMobileSchool = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/getUpdatePartyMobileSchool`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addUserBulk = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/addUserBulk`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addSchoolBulk = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/addSchoolBulk`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addBulkDistributor = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/addBulkDistributor`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addBulkTransporter = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/addBulkTransporter`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addBulkStockist = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/addBulkStockist`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getSchoolById = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/getSchoolById`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getRegistrationByIdForWeb = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getRegistrationByIdForWeb`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const getRegistrationById = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getRegistrationById`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getSOBOforOlympiadByRegId = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getSOBOforOlympiadByRegId`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getInvoiceforOlympiadByRegId = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getInvoiceforOlympiadByRegId`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getGenerateInvoiceDetails = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getGenerateInvoiceDetails`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getEmailOfAdminById = async (data) => {
  try {
    const response = await axiosInstance.post(`/user/getEmailOfAdminById`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const approveRejectMobileSchoolUpdate = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/approveRejectMobileSchoolUpdate`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getUpdatePartyMobileDistributor = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/getUpdatePartyMobileDistributor`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const approveRejectMobileDistributorUpdate = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/approveRejectMobileDistributorUpdate`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const returnOrderItems = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/returnOrderItems`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getOrderTrackingStatus = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/getOrderTrackingStatus`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getSchoolDataBasedOnId = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/getSchoolDataBasedOnId`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const getDeliveryStatus = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getDeliveryStatus`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const addOrderItemToTracking = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/addOrderItemToTracking`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const saveAutomationLogs = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/saveAutomationLogs`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const updateOrderItemToTracking = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/updateOrderItemToTracking`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchDataForDashbord = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/fetchDataForDashbord`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const createExpense = async (data) => {
  try {
    const response = await axiosInstance.post(`/expense/createExpense`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addExpensePurpose = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/addExpensePurpose`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addAddress = async (data) => {
  try {
    const response = await axiosInstance.post(`/address/addAddress`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const updateExpensePurpose = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/updateExpensePurpose`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const deleteExpensePurpose = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/deleteExpensePurpose`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const deletePincodeFromAddress = async (data) => {
  try {
    const response = await axiosInstance.post(`/address/deletePincodeFromAddress`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getSpecimenToUser = async (data) => {
  try {
    const response = await axiosInstance.post(`/specimen/getSpecimenToUser`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const getSpecimenLineItemsById = async (data) => {
  try {
    const response = await axiosInstance.post(`/specimen/getSpecimenLineItemsById`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const filterSpecimenToUser = async (data) => {
  try {
    const response = await axiosInstance.post(`/specimen/filterSpecimenToUser`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const filterOrderTrackingStatus = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/filterOrderTrackingStatus`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchReturnOrders = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/fetchReturnOrders`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchReturnOrdersFilter = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/fetchReturnOrdersFilter`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const editSeriesSet = async (data) => {
  try {
    const response = await axiosInstance.post(`/product/editSeriesSet`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const editCollection = async (data) => {
  try {
    const response = await axiosInstance.post(`/collection/editCollection`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getDistributorByID = async (data) => {
  try {
    const response = await axiosInstance.post(`/party/getDistributorByID`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getRequestTypeList = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getRequestTypeList`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}



const getStates = async (data) => {
  try {
    const response = await axiosInstance.post(`/picklist/getStates`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addSpecimenToUser = async (data) => {
  try {
    const response = await axiosInstance.post(`/specimen/addSpecimenToUser`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const approveRejectSpecimenToUser = async (data) => {
  try {
    const response = await axiosInstance.post(`/specimen/approveRejectSpecimenToUser`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const geoFencingToggle = async (data) => {
  try {
    const response = await axiosInstance.post(`/visit/geoFencingToggle`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const getGeoFencingToggle = async (data) => {
  try {
    const response = await axiosInstance.post(`/visit/getGeoFencingToggle`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const uploadTarget = async (data) => {
  try {
    const response = await axiosInstance.post(`/target/uploadTarget`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const addSchoolBulk11 = async (formData) => {
  try {
    const response = await axiosInstance.post(`/party/addSchoolBulk`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const createBulkSOBOforOlympiad = async (formData) => {
  try {
    const response = await axiosInstance.post(`/olympiad/createBulkSOBOforOlympiad`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const createBulkGenerateInvoice = async (formData) => {
  try {
    const response = await axiosInstance.post(`/olympiad/createBulkGenerateInvoice`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};
const createBulkOlympiadRegistration = async (formData) => {
  try {
    const response = await axiosInstance.post(`/olympiad/createBulkOlympiadRegistration`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};


const createBulkGenerateInvoiceRC = async (formData) => {
  try {
    const response = await axiosInstance.post(`/olympiad/createBulkGenerateInvoiceRC`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const uploadTransactionExcel = async (formData) => {
  try {
    const response = await axiosInstance.post(`/olympiad/uploadTransactionExcel`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};


const productByExcel = async (formData) => {
  try {
    const response = await axiosInstance.post(`/product/addProductByExcel`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });

    if (response) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const uploadAllottedSpecimen = async (formData) => {
  try {
    const response = await axiosInstance.post(`/product/uploadAllottedSpecimen`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });

    if (response) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

const addBulkDistributor11 = async (formData) => {
  try {
    const response = await axiosInstance.post(`/party/addBulkDistributor`, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Ensures correct file upload format
      }
    });

    if (response.status === 200) {
      return response.data; // Return the actual response data
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};


const consentOtpSend = async (data) => {
  try {
    const response = await axiosInstance.post(`/consent/getConsent`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const consentOtpSubmit = async (data) => {
  try {
    const response = await axiosInstance.post(`/consent/approveConsent`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const consentOtpResend = async (data) => {
  try {
    const response = await axiosInstance.post(`/consent/resendOtpForConsent`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}
const fetchRetunOrderLineItem = async (data) => {
  try {
    const response = await axiosInstance.post(`/order/fetchRetunOrderLineItem`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const orderReport = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/orderReport`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const visitDetailReport = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/visitDetailReport`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}


const visitSummarizedReport = async (data) => {
  try {
    const response = await axiosInstance.post(`/dashboard/visitSummarizedReport`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
}

const fetchOlympiad = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/olympiad/getAllOlympiadRegistrationsWithFilter`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getSetOffRegistartion = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/olympiad/getSetOffRegistartion`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllRegistrationGroupedByPartyId = async (data) => {
  try {
    //console.log("hellomamn",data)
    const response = await axiosInstance.post(`/olympiad/getAllRegistrationGroupedByPartyId`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateOlympiadStatus = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/updateOlympiadStatus`,
      data
    );

    // ✅ success check
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
};

const downloadOlympiadExcel = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/downloadOlympiadExcel`,
      data,
      {
        responseType: "blob", // 🔥 important
      }
    );

    if (response.status === 200) {
      return response.data; // blob
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
};

const downloadUploadedTransactionExcel = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/downloadUploadedTransactionExcel`,
      data,
      {
        responseType: "blob", // 🔥 important
      }
    );

    if (response.status === 200) {
      return response.data; // blob
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
};

const downloadSetOffRegistration = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/downloadSetOffRegistration`,
      data,
      {
        responseType: "blob", // 🔥 important
      }
    );

    if (response.status === 200) {
      return response.data; // blob
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
};

const downloadGroupedRegistrationExcel = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/downloadGroupedRegistrationExcel`,
      data,
      {
        responseType: "blob", // 🔥 important
      }
    );

    if (response.status === 200) {
      return response.data; // blob
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
};

const downloadOlympiadExcelById = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/downloadOlympiadExcelById`,
      data,
      {
        responseType: "blob", // 🔥 important
      }
    );

    if (response.status === 200) {
      return response.data; // blob
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
};


const downloadGroupedRegForExcelBySchoolId = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/downloadGroupedRegForExcelBySchoolId`,
      data,
      {
        responseType: "blob", // 🔥 important
      }
    );

    if (response.status === 200) {
      return response.data; // blob
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
};

const getMOMSummaryAPI = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/olympiad/getMOMSummaryAPI`,
      data
    );

    if (response.status === 200) {
      return response.data; // blob
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }

  } catch (error) {
    throw error;
  }
};

const getAllOlympiadRegTypes = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getAllOlympiadRegTypes`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addOlympiadRegType = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/addOlympiadRegType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateOlympiadRegType = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateOlympiadRegType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteOlympiadRegType = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/deleteOlympiadRegType`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllOlympiadPaymentModes = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getAllOlympiadPaymentModes`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addOlympiadPaymentMode = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/addOlympiadPaymentMode`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateOlympiadPaymentMode = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateOlympiadPaymentMode`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteOlympiadPaymentMode = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/deleteOlympiadPaymentMode`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAllOlympiadMediums = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getAllOlympiadMediums`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addOlympiadMedium = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/addOlympiadMedium`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateOlympiadMedium = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateOlympiadMedium`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteOlympiadMedium = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/deleteOlympiadMedium`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllOlympiadSubjects = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getAllOlympiadSubjects`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addOlympiadSubject = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/addOlympiadSubject`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateOlympiadSubject = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateOlympiadSubject`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteOlympiadSubject = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/deleteOlympiadSubject`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAllOlympiadClasses = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getAllOlympiadClasses`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addOlympiadClass = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/addOlympiadClass`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateOlympiadClass = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateOlympiadClass`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteOlympiadClass = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/deleteOlympiadClass`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllOlympiadDates = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getAllOlympiadDates`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addOlympiadDate = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/addOlympiadDate`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateOlympiadDate = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateOlympiadDate`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteOlympiadDate = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/deleteOlympiadDate`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllOlympiadShipmentItems = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getAllOlympiadShipmentItems`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addOlympiadShipmentItem = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/addOlympiadShipmentItem`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateOlympiadShipmentItem = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateOlympiadShipmentItem`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteOlympiadShipmentItem = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/deleteOlympiadShipmentItem`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const getAllClassSubjectMappings1 = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getAllClassSubjectMappings`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const addClassSubjectMapping = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/addClassSubjectMapping`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateClassSubjectMapping = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateClassSubjectMapping`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteClassSubjectMapping = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/deleteClassSubjectMapping`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};


const getAllSubjectSkuMapping = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/getAllSubjectSkuMapping`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const createSubjectSkuMapping = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/createSubjectSkuMapping`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const updateSubjectSkuMapping = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/updateSubjectSkuMapping`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

const deleteSubjectSkuMapping = async (data) => {
  try {
    const response = await axiosInstance.post(`/olympiad/deleteSubjectSkuMapping`, data);

    // Check if the request was successful (status code 200)
    if (response.status === 200) {
      // Return the data from the response
      //console.log("TESTAPIRUN", response.data);

      return response.data;
    } else {
      // If the request was not successful, handle the error
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    //console.error(error);
    throw error;
  }
};

let exportedFunctions = {
  fetchAllReasonForForceVisit,
  getFeedback,
  getNextStep,
  getWorkDone,
  login,
  verifyUserSession,
  fetchEmployees,
  fetchLeadSource,
  getMittstoreProduct,
  fetchLeadRating,
  fetchLeadStatus,
  addLeadSource,
  updateLeadSource,
  deleteLeadSource,
  deleteOfRoutParty,
  updateDateOfRoutParty,
  deleteOrder,
  addLeadRating,
  updateLeadRating,
  deleteLeadRating,
  addLeadStatus,
  updateLeadStatus,
  deleteLeadStatus,
  addVisitOutcomes,
  updateVisitOutcomes,
  deleteVisitOutcomes,
  getStockistAll,
  fetchVisits,
  getLatLong,
  fetchAllVisit,
  fetchVisitById,
  endVisitByWeb,
  endVisitByWebForForceClose,
  getDataForAppDropDown,
  getAllDataForDropdownParty,
  fetchAttendance,
  getAttendanceOfAll,
  getAttendanceOfAllPunchedIn,
  getAttendanceOfAllNotPunchedIn,
  getAttendanceOfAllAllStaff,
  getTodayAttendancePnches,
  getAttendanceDetailsByDate,
  getTodayNotPunchedUsers,
  getTodayAllPunchStatus,
  exportFetchAttendance,
  fetchOrder,
  fetchOrderForTracking,
  fetchOrderLineItem,
  getOrderReport,
  getReturnOrderLineItemByReturnReasonId,
  approverejectOrder,
  updateAsmApproval,
  getDistributor,
  getTotalStudentByPartyId,
  getSchool,
  getAllSchool,
  getAllSchoolForMerge,
  getStockist,
  editPartySchool,
  createNewUser,
  fetchPinCode,
  getUserById,
  getUsersForView,
  getCountVisit,
  addDistributor,
  getWorkType,
  startAttendance,
  endAttendance,
  fetchPartyType,
  fetchProduct,
  testApi,
  addVisit,
  getForecastReport,
  getFinancialReport,
  getPipelineReport,
  fetchRoles,
  addRole,
  getBoard,
  getMedium,
  fetchSeries,
  fetchProductById,
  getClass,
  addSeries,
  createOrder,
  updateRoleAccess,
  getRole,
  editDistributor,
  updateVisit,
  addProduct,
  updateProduct,
  fetchProduct1,
  getMittplusProductGroups,
  addMittplusProductGroups,
  updateMittplusProductGroups,
  deleteMittplusProductGroups,
  getProductGroups,
  addProductGroups,
  updateProductGroups,
  deleteProductGroups,
  fetchProductMittplus,
  addMittplusProduct,
  getReturnReasons,
  addReturnReasons,
  updateReturnReasons,
  deleteReturnReasons,
  addSchoolCategory,
  updateSchoolCategory,
  deleteSchoolCategory,
  addDocumentListSchool,
  deleteDocumentListSchool,
  addDeliveryStatus,
  updateDeliveryStatus,
  getDistributorA,
  deleteDeliveryStatus,
  updateMittplusProduct,
  deleteMittplusProduct,
  deleteTransporter,
  deleteProduct,
  getProducts,
  addProductBulk,
  productByExcel,
  uploadAllottedSpecimen,
  getSubject,
  addSchool,
  getRoutePlan,
  getRouteplanById,
  approveRoute,
  approvePartialRouteNotification,
  getPartyLead,
  addRoutePlan,
  addPartyInRouteLineItems,
  updateRoutePlan,
  updateOrderDetails,
  approveRejectParty,
  fetchReportingManagerRole,
  getUsersOnRole,
  editUser,
  signout,
  getCollection,
  addCollection,
  approveRejectCollection,
  getGivenType,
  getPaymentType,
  getSpecimen,
  addSpecimen,
  updateSpecimen,
  deleteSpecimen,
  deleteUser,
  suspendedUser,
  activateUser,
  fetchDashboardUsers,
  fetchDashboardSchool,
  fetchDashboardSchoolErpOnboard,
  fetchDashboardDistributor,
  fetchDashboardTotalRevenueOrder,
  fetchDashboardProductRank,
  fetchDashboardVisitVsOrderUser,
  fetchDashboardDistributorOnboardingList,
  fetchDashboardSchoolOnboardingList,
  fetchDashboardEmployeeWithRevenue,
  fetchDashboardTotalEarningMonthWise,
  fetchDashboardTotalEarningSchoolMonthWise,
  fetchDashboardOrderVsSpecimen,
  fetchDashboardTotalEarningDistributorMonthWise,
  filterSchool,
  filterDistributor,
  filterVisit,
  filterAttendance,
  filterOrder,
  deleteSchool,
  deleteStockist,
  deleteDistributor,
  filterOrderDistributor,
  filterRoutePlan,
  filterCollection,
  getSeriesCategory,
  addSeriesCategory,
  updateSeriesCategory,
  deleteSeriesCategory,
  getStatusType,
  getVehicleType,
  getLeadParty,
  getPartyLeadAdmin,
  getTransporters,
  getSchoolCategories,
  getVisitOutcomes,
  rejectVisit,
  addLeadBulk,
  addLeadAdmin,
  addTransporter,
  updateTransporter,
  deleteLead,
  fetchAttendanceForReport,
  getAddOnListWeb,
  getAddOnProducttWeb,
  getRemarkInPicklist,
  deleteRemarkInPicklist,
  addRemarkInPicklist,
  updateRemarkInPicklist,
  addClusterInPicklist,
  getClusterInPicklist,
  deleteClusterInPicklist,
  updateClusterInPicklist,
  getAllSessions,
  addSession,
  updateSession,
  updateSessionStatus,
  deleteSession,
  updateEmailOfAdmin,
  deleteEmailOfAdmin,
  addEmailOfAdmin,
  getEmailOfAdmin,
  getEmailOfAdminById,
  deleteWarehouseInPicklist,
  updateWarehousekInPicklist,
  getWareHouseInPicklist,
  addWarehouseInPicklist,
  saveAddOnList,
  saveaddOnProducts,
  resetDeviceId,
  getUsersFieldRole,
  getSchoolForDropDown,
  getContactPersonRole,
  getGrade,
  getDaType,
  getVisitType,
  getVisitTypeCheck,
  addVisitTypeCheck,
  updateVisitTypeCheck,
  swipeOwnerIdForSchool,
  getManager,
  fetchProductByCategory,
  getRouteVisitType,
  getRecieveCollectionName,
  getCollectiontype,
  sendOtp,
  verifyOtp,
  totalTimeWorkedReport,
  calculateTimeForSchoolAndDistributor,
  resendOTP,
  fetchLogs,
  fetchNotifications,
  getAllNotification,
  getPartyLocation,
  MarkNotificationsRead,
  addWorkType,
  updateWorkType,
  deleteWorkType,
  addPartyType,
  updatePartyType,
  deletePartyType,
  addSubject,
  updateSubject,
  deleteSubject,
  addClass,
  updateClass,
  deleteClass,
  addBoard,
  updateBoard,
  deleteBoard,
  addMedium,
  updateMedium,
  deleteMedium,
  addGivenType,
  updateGivenType,
  deleteGivenType,
  addPaymentType,
  updatePaymentType,
  deletePaymentType,
  addVehicleType,
  updateVehicleType,
  deleteVehicleType,
  addStatusType,
  updateStatusType,
  deleteStatusType,
  addWorkDone,
  updateWorkDone,
  deleteWorkDone,
  addNextStep,
  updateNextStep,
  deleteNextStep,
  addFeedback,
  updateFeedback,
  deleteFeedback,
  addGrade,
  updateGrade,
  deleteGrade,
  addContactPersonRole,
  updateContactPersonRole,
  deleteContactPersonRole,
  getSchoolTypeList,
  addDaType,
  updateDaType,
  deleteDaType,
  addVisitType,
  updateVisitType,
  deleteVisitType,
  addCollectionType,
  updateCollectionType,
  deleteCollectionType,
  addrecieveCollectionName,
  updaterecieveCollectionName,
  deleterecieveCollectionName,
  addExpensePurpose,
  updateExpensePurpose,
  deleteExpensePurpose,
  addBookType, getBookType,
  addRouteVisitType,
  updateRouteVisitType,
  deleteRouteVisitType,
  fetchAttendanceById,
  getUpdatePartyMobileSchool,
  addSchoolBulk,
  addUserBulk,
  addBulkDistributor,
  addBulkDistributor11,
  addBulkStockist,
  getStockistForDropDown,
  addStockist,
  addIncentiveNew,
  addIncentiveNewCondition,
  getRegistrationById,
  getSchoolById,
  approveRejectMobileSchoolUpdate,
  getUpdatePartyMobileDistributor,
  approveRejectMobileDistributorUpdate,
  fetchExpense,
  getExpenseTA,
  getExpenseDA,
  getExpenseTADA,
  getExpenseTADAForWeb,
  getExpenseType,
  getExpenseSubType,
  addExpenseType,
  addExpenseSubType,
  updateExpenseType,
  updateExpenseSubType,
  deleteExpenseType,
  deleteExpenseSubType,
  getExpensePurpose,
  getallparty,
  uploadImage,
  uploadImageApi,
  createExpense,
  returnOrderItems,
  getOrderTrackingStatus,
  getSchoolDataBasedOnId,
  getDeliveryStatus,
  addOrderItemToTracking,
  updateOrderItemToTracking,
  getSpecimenToUser,
  getSpecimenLineItemsById,
  filterSpecimenToUser,
  fetchDataForDashbord,
  filterOrderTrackingStatus,
  fetchReturnOrders,
  fetchReturnOrdersFilter,
  getDistributorByID,
  addSpecimenToUser,
  approveRejectSpecimenToUser,
  uploadTarget,
  geoFencingToggle,
  getGeoFencingToggle,
  consentOtpResend,
  consentOtpSend,
  exportUsers,
  getUsersWeb,
  fetchRetunOrderLineItem,
  orderReport,
  visitDetailReport,
  visitSummarizedReport,
  consentOtpSubmit,
  getIncentiveList,
  getIncentiveRules,
  updateReason,
  updateCity,
  getReasonList,
  getAllCities,
  addReason,
  addCity,
  deleteReason,
  deleteCity,
  deleteSchoolType,
  getAllAttendanceConfigs,
  deleteAttendanceConfig,
  addAttendanceConfig,
  getRequestTableList,
  updateAttendanceConfig,
  addSchoolBulk11,
  uploadTransactionExcel,
  verifyTransactions,
  // consentOtpSubmitorderReport,
  getAllDistricts,
  getAllRouteNames,
  GetAllIncentives,
  addDistributorToStockist,
  editSeriesSet,
  editCollection,
  editAddOnList,
  editAddOnProducts,
  deleteAddOnProducts,
  getAddOnsMenu,
  getAttendanceConfig,
  deleteAddOnList,
  fetchSingleOrder,
  getAddOns,
  deleteCollection,
  getWarehouseinPicklist,
  getAllDistri,
  uploadMultipleImages,
  addCustomerType,
  editStockist,
  getInputSourceList,
  getAllAssignedSpecimenItems,
  getAllSpecimens,
  getAllottedSpecimen,
  getSpecimenItemsById,
  getStates,
  updateInputSource,
  updateCustomerType,
  ReleasePartyLocation,
  ReleaseBaseLocatioForUser,
  deleteIncentive,
  deleteIncentiveRule,
  updateLatLongApprovalStatus,
  mergeParty,
  PartyUpdate,
  getLanguage,
  addBulkTransporter,
  updateExpenseApproval,
  editIncentive,
  editIncentiveCondition,
  getAuthor,
  getSchoolCategory,
  deleteSeriesSet,
  getDocumentListSchool,
  updateDocumentListSchool,
  addSchoolType,
  addInputSource,
  fetchPincodeFromAddress,
  getAddOnsList,
  updatePincodeFromAddress,
  addAddress,
  releaseUserLocation,
  getQuestionCategory,
  getUsersForWork,
  getAllotSpecimens,
  getMyAllotSpecimens,
  getAllSpecimensAlloted,
  fetchNotificationForWeb,
  getRequestTypeList,
  fetchOrderDash,
  getAllDataForDashBoard,
  getPartyCountAssignedOrNot,
  getVisitSummaryData,
  getDiscrepancyReportData,
  getMergedParty,
  getUsersBasedOnManager,
  updateMeetingWithDecisionMaker,
  getCustomerTypeList,
  fetchCurrentVisit,
  getUpdatedAllowances,
  getPartyVisitCounts,
  getNotRoutePlanCreatedUsers,
  getForceVisitClosedUsers,
  getOverallAvgVisitsPerDay,
  getLocationMismatchCount,
  getAvgDailyVisitsPerUser,
  getUsersBelowAvgVisitMark,
  getFollowUpVisitWithStatusReport,
  getCountFollowupVisits,
  getCountVisitForWeb,
  getDashboardTotalsAll,
  exportData,
  acceptedSpecimenToUser,
  deleteInputSource,
  updateSchoolType,
  saveAllotSpecimen,
  startVisit,
  getSpecimenProduct,
  createAccessModule,
  getAccessModules,
  getProductWithSeries,
  getDropdownListForOrder,
  getOlympiadDropdownData,
  getDropdownListForSpecimen,
  fetchAccessModules,
  makePayloadForMittlernIntigration,
  deleteCustomerType,
  getFollowupChangedDateReport,
  getAutoVisitClosedUsers,
  getMyAcceptedAllotSpecimens,
  getVisitWithoutMeeting,
  getJointMeeting,
  batchRejectOrders,
  batchApproveOrders,
  verifyAllowance,
  getDailyVisitSummaryAt4PM,
  getSummaryOne,
  getSummaryTwo,
  approveAllowance,
  funcForBaseURL,
  convertToOrder,
  funcForMittlernURL,
  functionMittlernSeries,
  functionMittlernSeriesName,
  createOlympiadRegistration,
  createNewTicket,
  saveSOBOforOlympiad,
  updateStudyMaterialSOAttachment,
  updateInvoiceAttachments,
  updateInvoiceAttachmentsRC,
  updateOlympiadRegistration,
  getAllClassSubjectMappings,
  getSOBOforOlympiadByRegId,
  convertToOrderForWeb,
  getFAQ,
  saveAutomationLogs,
  releaseDeviceId,
  updateFAQ,
  sendNotification,
  deletePincodeFromAddress,
  createGenerateInvoice,
  getAddOnProducttWeb1,
  getAllOnbordedDistributors,
  getAllRegistrationGroupedByPartyId,
  getAllAreaSchool,
  getRegistrationByIdForWeb,
  getAllAreaDistributor,
  getAutomationLogs,
  calculateIncentiveForAllUsers,
  fetchOrderItemAll,
  uploadTransactionAttachment,
  getInvoiceforOlympiadByRegId,
  getGenerateInvoiceDetails,
  updateSetOffAmount,
  findOrderBySchoolID,
  downloadGroupedRegForExcelBySchoolId,
  addAttachmentToSOBOEntry,
  getAllTickets,
  fetchOlympiad,
  updateOlympiadStatus,
  downloadOlympiadExcel,
  downloadGroupedRegistrationExcel,
  downloadOlympiadExcelById,
  createShipment,
  updateRegStatusForDelivered,getSetOffRegistartion,
  getMOMSummaryAPI,
  updateSOBOStatus,
  createBulkSOBOforOlympiad,
  downloadSetOffRegistration,
  downloadUploadedTransactionExcel,
  createBulkGenerateInvoice,
  createBulkGenerateInvoiceRC,
  createBulkOlympiadRegistration,
  updateInvoicetatus,
  getAllOlympiadRegTypes,
  addOlympiadRegType,
  updateOlympiadRegType,
  deleteOlympiadRegType,
  getAllOlympiadPaymentModes,
  addOlympiadPaymentMode,
  updateOlympiadPaymentMode,
  deleteOlympiadPaymentMode,
  addOlympiadMedium,
getAllOlympiadMediums,
updateOlympiadMedium,
deleteOlympiadMedium,
addOlympiadSubject,
getAllOlympiadSubjects,
updateOlympiadSubject,
deleteOlympiadSubject,
addOlympiadClass,
getAllOlympiadClasses,
updateOlympiadClass,
deleteOlympiadClass,
addOlympiadDate,
getAllOlympiadDates,
updateOlympiadDate,
deleteOlympiadDate,
addOlympiadShipmentItem,
getAllOlympiadShipmentItems,
updateOlympiadShipmentItem,
deleteOlympiadShipmentItem,
addClassSubjectMapping,
getAllClassSubjectMappings1,
deleteClassSubjectMapping,
getOlympiadDropdownData,
updateClassSubjectMapping,
getAllSubjectSkuMapping,
createSubjectSkuMapping,
updateSubjectSkuMapping,
deleteSubjectSkuMapping
}

export default exportedFunctions;